import isAbortError from "./isAbortError";

const rethrowUnlessAbort = (error) => {
  if (!isAbortError(error)) {
    throw error;
  }
};

export default rethrowUnlessAbort;
